// Studyo Today Backend
// Package studyo.today.item_duplication.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/item_duplication/v1/resources/copy_duplication_details.proto (package studyo.today.item_duplication.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/item_duplication/v1/resources/copy_duplication_details.proto.
 */
export const file_studyo_today_item_duplication_v1_resources_copy_duplication_details = /*@__PURE__*/
  fileDesc("CklzdHVkeW8vdG9kYXkvaXRlbV9kdXBsaWNhdGlvbi92MS9yZXNvdXJjZXMvY29weV9kdXBsaWNhdGlvbl9kZXRhaWxzLnByb3RvEipzdHVkeW8udG9kYXkuaXRlbV9kdXBsaWNhdGlvbi52MS5yZXNvdXJjZXMiGAoWQ29weUR1cGxpY2F0aW9uRGV0YWlsc0IxqgIuU3R1ZHlvLlRvZGF5Lkl0ZW1EdXBsaWNhdGlvbi5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the message studyo.today.item_duplication.v1.resources.CopyDuplicationDetails.
 * Use `create(CopyDuplicationDetailsSchema)` to create a new message.
 */
export const CopyDuplicationDetailsSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_item_duplication_v1_resources_copy_duplication_details, 0);

